package one.healthium.profile.ui.update_height

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.update
import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.models.UserProfileOptions
import one.healthium.ui.common.event_producer.EventProducer
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

internal class UpdateHeightViewModel(
    private val userInteractor: UserInteractor,
    appPreferences: AppPreferences,
) : BaseViewModel() {

    private val _state = MutableStateFlow(UpdateHeightUiState())
    val state = _state.asStateFlow()

    val uiMessages = UiMessageManager()
    val events = EventProducer<UpdateHeightEvent>()

    init {
        combine(
            userInteractor.observeUser(),
            appPreferences.isMetricFlow
        ) { userModel, isMetric ->
            _state.update { state ->
                state.copy(
                    userModel = userModel,
                    isMetric = isMetric,
                )
            }
        }
            .launch()
    }

    fun onHeightUpdated(value: Float?) {
        _state.value = _state.value.copy(updatedHeight = value)
    }

    fun onSaveClicked() {
        val updatedHeight = _state.value.updatedHeight
        if (_state.value.isHeightChanged.not() || updatedHeight == null || _state.value.isHeightValid.not()) {
            events.trigger(UpdateHeightEvent.OnHeightUpdated)
            return
        }

        launchGlobal {
            _state.update { state -> state.copy(loading = true) }
            try {
                userInteractor.updateUserProfile(UserProfileOptions(height = updatedHeight))
                events.trigger(UpdateHeightEvent.OnHeightUpdated)
            } catch (e: Exception) {
                Logger.e(e) { "Failed to update height" }
                uiMessages.add(UiMessage.throwable(e))
            } finally {
                _state.update { state -> state.copy(loading = false) }
            }
        }
    }
}